var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 6C0.75 5.0335 1.5335 4.25 2.5 4.25H21.5C22.4665 4.25 23.25 5.0335 23.25 6V18.5C23.25 19.4665 22.4665 20.25 21.5 20.25H2.5C1.5335 20.25 0.75 19.4665 0.75 18.5V6ZM2.5 5.75C2.36193 5.75 2.25 5.86193 2.25 6V18.5C2.25 18.6381 2.36193 18.75 2.5 18.75H21.5C21.6381 18.75 21.75 18.6381 21.75 18.5V6C21.75 5.86193 21.6381 5.75 21.5 5.75H2.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.75C7.5 10.7165 6.7165 11.5 5.75 11.5C4.7835 11.5 4 10.7165 4 9.75C4 8.7835 4.7835 8 5.75 8C6.7165 8 7.5 8.7835 7.5 9.75Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.7215L6.18133 12.6561C6.31225 12.4721 6.51172 12.3574 6.72827 12.3415C6.94483 12.3256 7.15726 12.4101 7.31075 12.5731L8.53916 13.8784L12.9106 9.23358C13.2037 8.92214 13.6789 8.92214 13.972 9.23358L20 15.6386V17H4V15.7215Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.7e6d5d25ea31716a4a37ef73aa280d98.svg";
export { ForwardRef as ReactComponent };